import { render, staticRenderFns } from "./CommonContentArea.vue?vue&type=template&id=24a808fe&scoped=true&"
import script from "./CommonContentArea.vue?vue&type=script&lang=js&"
export * from "./CommonContentArea.vue?vue&type=script&lang=js&"
import style0 from "./CommonContentArea.vue?vue&type=style&index=0&id=24a808fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a808fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
